/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';

export interface ButtonGroupProps {
  className?: string;
  children: React.ReactNode;
}

export default function ButtonGroup(props: ButtonGroupProps) {
  const { className, children } = props;
  return (
    <div
      role="group"
      className={className}
      css={{
        '& :nth-child(1):not(:nth-last-child(1))': {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderRight: 0,
          marginLeft: 0,
        },
        '& :not(:nth-child(1)):not(:nth-last-child(1))': {
          borderRadius: 0,
          borderRight: 0,
          marginLeft: 0,
        },
        '& :nth-last-child(1):not(:nth-child(1))': {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          marginLeft: 0,
        },
      }}
    >
      {children}
    </div>
  );
}
